import { UserFeedbackFilterByOption } from "src/constants";
import { useSession } from "src/hooks";
import { useGetFormSubmissions } from "src/http";
import { useUserFeedbackSettings } from "../hooks";
import { UserFeedbackList } from "./UserFeedbackList";
import { UserFeedbackListSkeleton } from "./UserFeedbackListSkeleton";

interface Props {
  userId: string;
  onClicked?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, formSubmissionGuid: string) => void;
  onDraftClicked?: (formSubmissionGuid: string, formGuid: string) => void;
}

const UserFeedbackReceivedList = (props: Props) => {
  const { userId: sessionUserId } = useSession();
  const { settings, updateSettings } = useUserFeedbackSettings(props.userId);
  const { data: unfilteredData, isLoading: isLoadingUnfiltered } = useGetFormSubmissions({
    filters: {
      [UserFeedbackFilterByOption.Receiver]: [props.userId],
      [UserFeedbackFilterByOption.ExcludeDrafts]: [(props.userId !== sessionUserId).toString()],
    },
  });
  const { data: filteredData, isLoading: isLoadingFiltered } = useGetFormSubmissions({
    filters: {
      ...settings.receivedFeedbackFilters,
      [UserFeedbackFilterByOption.Receiver]: [props.userId],
      [UserFeedbackFilterByOption.ExcludeDrafts]: [(props.userId !== sessionUserId).toString()],
    },
  });

  if (isLoadingUnfiltered || isLoadingFiltered || unfilteredData === undefined || filteredData === undefined) {
    return <UserFeedbackListSkeleton />;
  }

  return (
    <UserFeedbackList
      title="Received"
      unfilteredItems={unfilteredData}
      filteredItems={filteredData}
      groupBy={settings.receivedFeedbackGroupByOption}
      filters={settings.receivedFeedbackFilters}
      onGroupByChanged={(value) => updateSettings({ receivedFeedbackGroupByOption: value })}
      onFilterByChanged={(filters) => updateSettings({ receivedFeedbackFilters: filters })}
      onClicked={props.onClicked}
      onDraftClicked={props.onDraftClicked}
      enableFilterBySender
    />
  );
};

export { UserFeedbackReceivedList };
